/**
 * CashFlowLayout
 * 
 * Architecture: Navbar Top, Sidebar Below (allows dropdown to overflow)
 * Dedicated layout for the Cash Flow module with a streamlined sidebar.
 */

import { Outlet } from 'react-router-dom';
import { CashFlowSidebar } from './CashFlowSidebar';
import { Navbar } from './Navbar';
import { MobileMenuProvider } from '@/context/MobileMenuContext';

export function CashFlowLayout() {
  return (
    <MobileMenuProvider>
      <div className="flex h-screen flex-col overflow-hidden bg-gray-50">
        {/* Navbar spans full width at top */}
        <Navbar />
        
        {/* Sidebar + Main content below navbar */}
        <div className="flex flex-1 overflow-hidden">
          <CashFlowSidebar />
          <main className="flex-1 overflow-y-auto p-6 relative z-0">
            <Outlet />
          </main>
        </div>
      </div>
    </MobileMenuProvider>
  );
}
